module.exports = __webpack_public_path__ + "img/client-uai-pet.ba0a310a.jpg";